export * from './Tabs';
export * from './Tab/Tab';
export * from './TabPanel/TabPanel';
export * from './model';
import { provideChameleonDesignSystem } from '../common/ChameleonDesignSystem';
import { chameleonTabs } from './Tabs.definition';
import { chameleonTab } from './Tab/Tab.definition';
import { chameleonTabPanel } from './TabPanel/TabPanel.definition';
provideChameleonDesignSystem().register(chameleonTab(), chameleonTabPanel(), chameleonTabs());
